import type { PaymentStatus } from '@repo/graphql-types'
import { Z_INDEX_MODALS } from 'constants/modals'
import { getPaymentRecoveryModelFromPaymentStatus } from '../payment-recovery-dialog/normalizers'
import { PaymentRecoveryStatusDialog } from '../payment-recovery-dialog/payment-recovery-status-dialog'

export interface PaymentFailedModalProps {
  paymentStatus: PaymentStatus | null
  message: string | null
  onSettled?: () => void
  closeModal: () => void
}

export function PaymentFailedModal({
  paymentStatus,
  message,
  onSettled,
  closeModal,
}: PaymentFailedModalProps) {
  const recoveryModel = getPaymentRecoveryModelFromPaymentStatus({ paymentStatus, message })

  return (
    <PaymentRecoveryStatusDialog
      model={recoveryModel}
      onClose={() => {
        if (onSettled) {
          onSettled()
        }
        closeModal()
      }}
      zIndex={Z_INDEX_MODALS.oneClickUpgrade.modal}
      overlayZIndex={Z_INDEX_MODALS.oneClickUpgrade.modal - 1}
    />
  )
}
